import React from 'react'

import { DarawersProvider as DrawerManagerProviderLib } from '@/shared/lib/drawer-manager'

import registry from '../config/drawers-registry'

export default function DrawerManagerProvider({
	children,
}: {
	children: React.ReactNode
}) {
	return (
		<DrawerManagerProviderLib registry={registry}>
			{children}
		</DrawerManagerProviderLib>
	)
}
